<template>
  <highcharts class="charts" :options="chartOptions" ref="linechart"></highcharts>
</template>

<script>
export default {
  name: "test-case-chart",
  props: {
    chartData: Array
  },

  data() {
    return {
      chartOptions: {}
    };
  },

  created() {
    this.chartOptions = {
      chart: {
        polar: false
      },
      boost: {
        enabled: false
      },
      title: {
        text: ""
      },
      subtitle: {
        text: ""
      },
      yAxis: {
        title: {
          text: "",
          style: {
            fontSize: "14px"
          }
        },
        labels: {
          format: "{value}",
          style: {
            fontSize: "12px"
          }
        },
        type: "linear"
      },
      xAxis: {
        title: {
          text: "",
          style: {
            fontSize: "14px"
          }
        },
        allowDecimals: false,
        crosshair: {
          label: {
            style: {
              color: "white",
              fontWeight: "normal",
              fontSize: "12px",
              textAlign: "center"
            }
          },
          snap: true,
          width: 1,
          zIndex: 3,
          color: "#aab3b3"
        },
        labels: {
          style: {
            fontSize: "12px"
          }
        }
      },
      series: [],
      tooltip: {
        shared: true,
        valueDecimals: 3,
        dateTimeLabelFormats: {
          second: "%e.%m.%Y  [%H:%M:%S]",
          minute: "%e.%m.%Y  [%H:%M]",
          millisecond: "%e.%m.%Y  [%H:%M]"
        },
        style: {
          whiteSpace: "nowrap",
          fontSize: "14px"
        },
        pointFormat:
          "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y}</b><br/>",
        headerFormat: "<span style='font-size: 12px'>{point.key}</span><br/>",
        split: true,
        outside: false,
        followPointer: true,
        followTouchMove: true,
        animation: true
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadCSV",
              "downloadXLS",
              "downloadPNG",
              "downloadPDF",
              "viewData"
            ]
          }
        }
      },
      credits: {
        enabled: false
      },
      colors: [
        "#00bcd4",
        "#f44336",
        "#4caf50",
        "#ff9800",
        "#fb4579",
        "#9761c8",
        "#4b63ec",
        "#fb636a",
        "#206692",
        "#668891"
      ],
      legend: {
        verticalAlign: "top"
      },
      lang: {
        decimalPoint: "."
      },
      navigator: {
        enabled: false
      },
      pane: {
        background: []
      },
      rangeSelector: {
        enabled: false
      },
      responsive: {
        rules: []
      },
      noData: {
        useHTML: true
      },
      plotOptions: {
        series: {
          animation: true
        }
      },
      chartarea: {},
      plotarea: {}
    };
    this.chartOptions.title.text = "";
    this.chartOptions.yAxis.labels.format = "{value} %";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} %</b><br/>";
    this.chartOptions.xAxis.title.text = this.$lang.titles.test_case;
    this.chartOptions.yAxis.title.text = this.$lang.general.relative_error;
  },

  mounted() {
    this.chartOptions.series = [];

    this.chartData.forEach(item => {
      let seriesIndex = this.chartOptions.series.push({
        name: item.name,
        type: "spline",
        visible: true,
        data: item.data
      });
    });

    const { chart } = this.$refs.linechart;
    chart.redraw();
  }
};
</script>

<style scoped>
.charts {
  width: 100%;
}
</style>